import { FC } from 'react';

import { SvgIconName } from '~src/shared/SvgIcon';

import * as SC from './StarsList.sc';

export enum ListClass {
  coloredList = 'colored-list',
  goldFilled = 'gold-filled glow',
}

interface DefaultProps {
  starsLength: number;
  listCls: ListClass;
}

interface Props extends Partial<DefaultProps> {
  blank?: boolean;
  ratingIndex?: number;
}

const StarsList: FC<Props> = (props) => {
  const { starsLength = 5, listCls = ListClass.goldFilled } = props;
  const getColoredStarCls = (starIndex: number) => {
    let classNames;
    if (props.ratingIndex !== undefined) {
      if (props.ratingIndex > starIndex * 2 - 1) {
        classNames = 'full';
      } else if (props.ratingIndex === starIndex * 2 - 1) {
        classNames = 'half';
      } else {
        classNames = 'empty';
      }
    } else {
      classNames = 'white empty';
    }
    return classNames;
  };

  const renderStars = () => {
    const stars = [];
    for (let starIndex = 0; starIndex < starsLength; starIndex += 1) {
      let star;
      if (listCls === ListClass.coloredList) {
        const classNames = getColoredStarCls(starIndex);
        const svgName = `iconStar${classNames === 'half' ? 'Half' : ''}` as SvgIconName;
        star = (
          <SC.StarWrapper
            key={starIndex}
            className={`${listCls} ${classNames}`}
            $colorIndex={8 - (props.ratingIndex || 0)}
            name={svgName}
            $blank={props.blank}
          />
        );
      } else {
        star = <SC.StarWrapper className={listCls} key={starIndex} name="iconStar" />;
      }
      stars.push(star);
    }
    return stars;
  };

  return <SC.DisplayStarsContainer>{renderStars()}</SC.DisplayStarsContainer>;
};

export default StarsList;
